module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc_head"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454931959_epub_prf_r1"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454931959_epub_itr_r1"
    }
  }, [_c('em', [_vm._v("Introduction: Why Tesla Still Electrifies Us")])])]), _vm._v(" "), _c('div', {
    staticClass: "chap_toc"
  }, [_c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c01_r1"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("I.")]), _vm._v(" Hoover’s Stakeout")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c01_r1#c01-s1"
    }
  }, [_c('em', [_vm._v("An Iconic Inventor Dies")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c01_r1#c01-s2"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #1:")]), _vm._v(" Be Introspective")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("II.")]), _vm._v(" Catching Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c02_r1#c02-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tesla’s Creative Inheritance")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c02_r1#c02-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #2:")]), _vm._v(" Be Unrelentingly Curious")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("III.")]), _vm._v(" Flashes of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c03_r1#c03-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Psychology of Tesla")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c03_r1#c03-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #3:")]), _vm._v(" Practice Visualization")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("IV.")]), _vm._v(" From Prague to Pittsburgh")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c04_r1#c04-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Roving Electrician")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c04_r1#c04-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #4:")]), _vm._v(" Be Indispensable")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("V.")]), _vm._v(" The Wizard of Electricity")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c05_r1#c05-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tesla’s Lightning Show")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c05_r1#c05-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #5:")]), _vm._v(" Sell Your Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("VI.")]), _vm._v(" Power from the Earth and Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c06_r1#c06-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tesla’s Wireless World System")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c06_r1#c06-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #6:")]), _vm._v(" Zoom Out")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("VII.")]), _vm._v(" Weathering the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c07_r1#c07-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Fall of Wardenclyffe")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c07_r1#c07-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #7:")]), _vm._v(" Be Resilient")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("VIII.")]), _vm._v(" Man for All Seasons")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c08_r1#c08-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Adapting to a New, Turbulent Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c08_r1#c08-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #8:")]), _vm._v(" Reposition Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("IX.")]), _vm._v(" A Detective Story")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c09_r1#c09-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Searching for the Elusive Death Ray")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c09_r1#c09-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #9:")]), _vm._v(" Be Empathic")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "list_ornament"
  }, [_vm._v("X.")]), _vm._v(" The Once and Future Tesla")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c10_r1#c10-s1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Wizard’s Twenty-First-Century Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub_toc0"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_c10_r1#c10-s2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans0"
  }, [_vm._v("TeslAction #10:")]), _vm._v(" Be Chimeric")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_epi_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_ref_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("References & Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliographic Essay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_ack_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_cre_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Image Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781454931959_epub_ad_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bonus Feature")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a45530","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454931959_epub_toc_r1.vue
// module id = 72
// module chunks = 0